'use strict'

import $ from 'jquery'

let self

export default self = {
  container : document.getElementById('register-page'),

  init : () => {
    self.setupElements()
    self.registerEvents()
  },

  setupElements : () => {
    self.overlay = document.getElementById('termsOverlay')
    self.btnAgree = self.overlay.querySelector('.actions button.agree')
    self.form = document.getElementById('registerform')
    self.errorMessage = document.querySelector('.error-message')
    self.successMessage = document.querySelector('.success-message')
    self.agreeCheck = document.getElementById('agreeCheck')
    self.overlayTriggers = [...document.querySelectorAll('.trigger-overlay')]
  },

  registerEvents : () => {
    self.btnAgree.addEventListener('click', self.toggleOverlay)
    self.form.addEventListener('submit', self.onSubmit)
    self.overlayTriggers.forEach( button => button.addEventListener('click', self.toggleOverlay, false) )
  },

  toggleOverlay : e => {
    const rel = e.currentTarget.getAttribute('rel')

    self.overlay.classList.toggle('show')
    document.documentElement.classList.toggle('register-block')

    self.overlay.querySelector('.scroll').scrollTop = 0

    if (rel) {
      self.overlay.querySelector(`article[rel="${rel}"]`).classList.add('show')
    } else {
      self.overlay.querySelector(`article.show`).classList.remove('show')
    }
  },

  onSubmit : e => {
    e.preventDefault()
    const form = e.currentTarget
    const action = form.action

    if ( !self.agreeCheck.checked ) {
      return self.agreeCheck.parentNode.classList.add("error")
    } else {
      self.agreeCheck.parentNode.classList.remove("error")
    }

    $.ajax({
      url: action,
      type: 'post',
      data: $(self.form).serialize(),
      beforeSend : () => self.form.classList.add("disabled"),
      success : res => {
        const $html = $(res)
        const $err = $html.find('#login_error').html()
        const isError = $err !== undefined

        self.form.classList.remove("disabled")

        if ( isError ) {
          self.errorMessage.classList.remove('hidden')
          self.successMessage.classList.add('hidden')
          return self.errorMessage.innerHTML = $err
        }

        self.errorMessage.classList.add('hidden')
        self.successMessage.classList.remove('hidden')
        self.form.classList.add('hidden')
      },
      error : err => console.error(err)
    })
  }
}
